import { ApiErrorResponseFromJSON } from '@ibe/api';
import { action, computed, observable, makeObservable } from 'mobx';
import Service from './Service';

class LoginService extends Service {
  public _token: string | null = null;

  constructor() {
    super();

    makeObservable(this, {
      _token: observable,
      token: computed,
      refreshToken: action
    });
  }

  get token(): string | null {
    return this._token;
  }

  async refreshToken(): Promise<string | null> {
    if (!this.api) {
      throw new Error(this.ERR_NO_API);
    }
    if (!this.authService) {
      throw new Error(this.ERR_NO_AUTHORIZATION_SERVICE);
    }
    try {
      this._token = await this.api.refreshToken();
      if (this._token) {
        this.authService.fromJwt(this._token);
      }
      return this._token;
    } catch (e) {
      throw ApiErrorResponseFromJSON(await (e as Response).json());
    }
  }
}

export default LoginService;
